export enum DataAccessRequestStatus {
  PendingVerification = 'PendingVerification',
  Approved = 'Approved',
  Rejected = 'Rejected'
}

export enum DataAccessRequestReviewSubStatus {
  AdditionalInformationRequired = 'additional-information-required'
}

/** Lifecycle on `DataAccessRequestVerificationDetail.sharing`. Absent sharing means it has not started. */
export enum DataAccessRequestSharingStatus {
  Pending = 'pending',
  Shared = 'shared',
  Failed = 'failed'
}

/** UI display status. `NotShared` is the federated-connection flag, not a missing `sharing` object. */
export enum DataAccessRequestSharingDisplayStatus {
  Processing = 'pending',
  Shared = 'shared',
  Failed = 'failed',
  NotShared = 'notShared'
}

export enum DataAccessRequestType {
  DataAccessRequest = 'data-access-request'
}

export enum DataAccessRequestAttachmentSubmission {
  Original = 'original',
  Additional = 'additional'
}

export enum StudyIdEvaluationOutcome {
  Matched = 'matched',
  Unmatched = 'unmatched',
  Conflict = 'conflict'
}

export enum StudyIdConflictKind {
  ApprovedDataAccessRequest = 'approvedDataAccessRequest',
  SchemaAccess = 'schemaAccess'
}

/** `Manual` covers any existing access that was not provisioned by a data access request. */
export enum StudyIdConflictSource {
  DataAccessRequest = 'dataAccessRequest',
  Manual = 'manual'
}
